// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__28Ru6","title":"AfterFrontImage_title__1aLDn"};